import { makeStyles } from 'tss-react/mui';

import { brandColors } from '@/styles/theme/values/brandColors';

interface Props {
  isOnDark?: boolean;
}

const useStyles = makeStyles<Props>({
  name: 'GlobalFAQ',
})(({ spacing, type, typography }, props) => ({
  container: {
    backgroundColor: props.isOnDark
      ? brandColors.tintsHeroBlue10
      : brandColors.tintsOffWhite60,
  },
  lastFaqSection: {
    '& .MuiPaper-root:last-child': {
      borderBottom: `${typography.pxToRem(1)} solid ${
        props.isOnDark ? 'rgba(255, 255, 255, 0.30)' : 'rgba(0, 0, 0, 0.20)'
      }`,
    },
  },
  faqsContainer: {
    marginTop: spacing(3),
  },
  footer: {
    ...type['18_regular'],
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: spacing(0),
    color: props.isOnDark
      ? brandColors.tintsOffWhite40
      : brandColors.tintsNeutral20,
    flexWrap: 'wrap',
    '&.MuiGrid2-root': {
      marginTop: spacing(3),
    },
  },
}));

export default useStyles;
